import { styled } from "@mui/material/styles";
import { MUIStyledCommonProps } from "@mui/system";
import { ComponentProps, ComponentType } from "react";
import SimpleBar from "simplebar-react";
import type { Theme } from "@mui/material/styles/createTheme";
export type Scrollbar = ComponentType<ComponentProps<typeof SimpleBar> & MUIStyledCommonProps<Theme>>;
export const Scrollbar = styled(SimpleBar)`` as Scrollbar;